module.exports = __webpack_public_path__ + "img/f127cbec-14f4-4050-8dbc-2e1beda66761.1c442dbb.jpg";